/*
 * Copyright (c) Nexign, JSC, 1992-2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Dmitriy Kvon
 * @version 1.17.0
 * @since 1.16.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';

export const PersonalDataDeleteModalStyled = styled.div.attrs({
    className: 'personal-data-delete-modal',
})`
    .delete-modal__title {
        margin-bottom: 8px;
    }

    .delete-modal__subtitle {
        margin-bottom: 24px;
        padding-left: 56px;
        padding-right: 56px;
        color: ${colors.textColorOpacity};
    }

    .delete-modal__body {
        padding-top: 24px;
        padding-bottom: 24px;
    }

    .delete-modal__text_bold {
        ${fonts.textMainBold};
    }

    .delete-modal__failure-text {
        white-space: pre-line;
        margin-bottom: 24px;
    }
`;
